/**
 * Bir nesnedeki `null`, `undefined` ve boş string (`''`) değerleri olan key'leri atar.
 * `0`, `false`, vb. gerçekten anlamlı değerler korunur. RTK Query endpoint'lerinde
 * GET query-string parametrelerini veya POST/PUT body alanlarını temizlemek için kullanılır.
 *
 * @param {Object} obj - Temizlenecek nesne
 * @returns {Object} - null/undefined/'' değerleri çıkarılmış yeni nesne
 */
export const cleanParams = (obj = {}) =>
    Object.fromEntries(
        Object.entries(obj).filter(([, v]) => v !== null && v !== undefined && v !== '')
    );
